import React from "react";
import PropTypes from "prop-types";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Row, Col } from "antd";
import { formatWeeklyLabel } from "../../../app/utils/dateTimeUtils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  indexAxis: "y",
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "right",
    },
    title: {
      display: true,
      text: "WEEKLY",
      color: "white",
      font: {
        family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        size: 23,
      },
    },
  },
  scales: {
    x: {
      title: {
        color: "white", // X-axis label color
      },
      ticks: {
        color: "white", // X-axis ticks color
      },
    },
    y: {
      title: {
        color: "white", // Y-axis label color
      },
      ticks: {
        color: "white", // Y-axis ticks color
      },
    },
  },
};

const WeeklyAttendance = ({ weeklyDatas = [] }) => {
  const chartData = {
    labels: weeklyDatas.map((d) => formatWeeklyLabel(d.from, d.to)),
    datasets: [
      {
        label: "",
        data: weeklyDatas.map((d) => d.totalPresent),
        borderColor: "white",
        backgroundColor: "white",
      },
    ],
  };

  return (
    <Row>
      <Col span={24}>
        <div className="weekly-attendance-container">
          <Bar options={options} data={chartData} />
        </div>
      </Col>
    </Row>
  );
};

WeeklyAttendance.propTypes = {
  weeklyDatas: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string,
      totalPresent: PropTypes.number,
    })
  ),
};

export default WeeklyAttendance;
